var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users-dashboard-multi-Selected",
    transform: "translate(-434.000000, -176.000000)",
    fill: "#DC0032",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(435.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-entry",
    transform: "translate(0.153846, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0327979,3.38896941 C17.7587229,1.16428376 14.7543615,0 11.75,0 C8.7456385,0 5.7410977,1.16428376 3.46720208,3.38896941 C-1.15573403,7.91239167 -1.15573403,15.0740967 3.46720208,19.5973434 C5.75508646,21.8357162 8.7456385,23 11.75,23 C14.7543615,23 17.7449135,21.8357162 20.0327979,19.5973434 C24.655734,15.0740967 24.655734,7.91239167 20.0327979,3.38896941 Z M5.41038837,5.29042815 C7.16078045,3.59129331 9.4484855,2.66986848 11.75,2.66986848 C13.5554505,2.66986848 15.3745311,3.25420379 16.9457591,4.34654234 L11.75,9.43008423 L4.44569994,16.5768738 C1.85885002,13.0004959 2.23798209,8.40811157 5.41038837,5.29042815 Z M18.0894323,17.6960602 C16.3392195,19.395195 14.0515145,20.3166199 11.75,20.3166199 C9.94454946,20.3166199 8.12546888,19.7322845 6.55424088,18.639946 L19.0543,6.40961457 C21.6409706,9.98581697 21.2620179,14.5782013 18.0894323,17.6960602 L18.0894323,17.6960602 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.32b2dffc.svg";
export { ForwardRef as ReactComponent };